import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M9 2h6l3 7H6l3-7Z", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 9v13", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M9 22h6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LampFloor";
const LampFloor = memo(themed(Icon));
export {
  LampFloor
};
//# sourceMappingURL=lamp-floor.js.map
